/*@flow*/
import React from 'react';
import * as t from 'lib/t';
import type { StructType } from 'lib/t/types';
import { NonEmptyString } from 'types/tcomb';
import { DataPanelTags } from 'lib/templates';
import FormatterListTemplate from './templates/FormatterList';
import QueryTemplate from './templates/Query';
import BboxTemplate from './templates/Bbox';
import LayerIdTemplate from './templates/LayerId';

const cannotBeBlank = (s) => !s && 'cannot be blank.';

const IDType = t.Any;
const LayerIdType = IDType.opt({
  label: 'Layer',
  template: LayerIdTemplate,
});
const FormatterType = t.struct({
  name: t.mysubtype(NonEmptyString, cannotBeBlank, 'Name'),
  labelTemplate: t.String,
  valueTemplate: t.maybe(t.String),
});

export const schema: StructType = t.struct({
  panel: t
    .struct({
      id: IDType.opt({ type: 'hidden' }),
      name: t.mysubtype(t.String, cannotBeBlank, 'Name'),
      description: t.mysubtype(t.String, cannotBeBlank, 'Description').opt({
        help: <span>e.g. Represents a data panel.</span>,
      }),
      tags: t.list(t.String, 'Tags').opt({
        template: DataPanelTags,

        attrs: {
          placeholder: 'Start typing...',
        },
      }),
      source: t.mysubtype(t.String, cannotBeBlank, 'Source'),
      layerId: LayerIdType,
      bbox: t.String.opt({
        label: 'Effective Area (required)',
        template: BboxTemplate,
      }),
      table: t
        .struct({
          query: t.mysubtype(t.String, cannotBeBlank, 'Query').opt({
            template: QueryTemplate,
          }),
          parameters: t.list(t.String).opt({
            disableOrder: true,
          }),
          formatters: t.maybe(t.list(FormatterType)).opt({
            template: FormatterListTemplate,
          }),
        })
        .opt({
          legend: <h4 className="mt-3">Table (required)</h4>,
        }),
      graphics: t
        .list(
          t.struct({
            name: t.mysubtype(t.String, cannotBeBlank, 'GraphicsName'),
            description: t
              .mysubtype(t.String, cannotBeBlank, 'GraphicsDescription')
              .opt({
                type: 'textarea',
              }),
            query: t.mysubtype(t.String, cannotBeBlank, 'GraphicsQuery').opt({
              template: QueryTemplate,
              help: <span>Fetches data for graphic.</span>,
            }),
            spec: t.mysubtype(t.String, cannotBeBlank, 'GraphicsSpec').opt({
              template: QueryTemplate,
              label: 'Vega Spec (required)',
              help: (
                <span>
                  Describes the visualization using{' '}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://vega.github.io/vega-lite/"
                  >
                    Vega-Lite
                  </a>
                  .
                </span>
              ),
            }),
          })
        )
        .opt({
          legend: <h4 className="mt-3">Graphics & Visualizations</h4>,
        }),
    })
    .opt({ legend: '' }),
});
